import { Component } from '@angular/core';

@Component({
  selector: 'bfd-extract-consolidated-extracts',
  templateUrl: './bfd-extract-consolidated-extracts.component.html',
  styleUrls: ['./bfd-extract-consolidated-extracts.component.scss'],
})
export class ExtractConsolidatedExtractsComponent {
  public menu = [
    '2025',
    '2024',
    '2023',
    '2022'
  ];

  public mockTable = [
    'Março/2025',
    'Fevereiro/2025',
    'Janeiro/2025'
  ]

  handleRange(range: { start: Date; end: Date }) {
    console.log('Range selecionado:', range);
  }

  public changePage(page): void {
    console.log(page)
  }
}
